import { Button, useTheme } from '@mui/material';
import { ColorDot } from 'apps/app/src/components/design/ColorDot';
import React from 'react';
import NetSuite from '../../../../../assets/images/net-suite-logo.png';
import { useDialog } from '../../../../../hooks/use-dialog';
import { ConnectNetSuiteModal } from '../../../../integrations/IntegrationsPage/integrations-page-components/ConnectNetSuiteModal';

type NetsuiteButtonProps = {
  isConnected: boolean;
};

export const NetsuiteButton: React.FC<NetsuiteButtonProps> = ({ isConnected }) => {
  const vyTheme = useTheme();
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <ConnectNetSuiteModal
        open={isDialogOpen}
        onClose={handleClose}
      />

      <div
        className="flex items-center justify-between gap-2"
        key="HubSpot"
      >
        <div className="flex items-center gap-3">
          <ColorDot color={isConnected ? vyTheme.palette.success.main : vyTheme.palette.grey[300]}/>
          <div className="flex h-12 w-16 items-center justify-center">
            <NetsuiteIcon/>
          </div>
          <h2>Netsuite</h2>
        </div>
        {isConnected ? (
          <Button
            variant='outlined'
            size='small'
            color='error'
          >
            Disconnect
          </Button>
        ) : (
          <Button
            variant='outlined'
            size='small'
            color='success'
            onClick={handleOpen}
          >
            Connect
          </Button>
        )}
      </div>
    </>
  );
};

const NetsuiteIcon = () => (
  <img
    className="h-10 w-10 cursor-pointer"
    src={NetSuite}
    alt="NetSuite"
  />
);